// Entity type enum - only Legislation and WorkspaceDocument are supported in global search
export enum SearchEntityType {
  Legislation = "Legislation",
  Workspace = "Workspace", // Keep for backward compatibility but not used in global search
  WorkspaceDocument = "WorkspaceDocument",
  Chat = "Chat", // Keep for backward compatibility but not used in global search
}

// Entity types supported in the new global search
export const GLOBAL_SEARCH_ENTITY_TYPES = [
  SearchEntityType.Legislation,
  SearchEntityType.WorkspaceDocument,
] as const;

export type GlobalSearchEntityType =
  (typeof GLOBAL_SEARCH_ENTITY_TYPES)[number];

export interface LegislationValidityScheme {
  isRevoked?: boolean;
  isHistorical?: boolean;
  isNullified?: boolean;
}

export interface Search {
  id?: string;
  tab: GlobalSearchTab;

  searchTerm: string;
  searchTags?: string[];

  // Filters for legislation (namespaced keys, e.g. datasource, retsinformation::status)
  filters?: Record<string, string[]>;
  /** Filters for workspace document search: metadata field names + reserved "document_title" */
  workspaceDocumentFilters?: Record<string, string[]>;

  isFavorite?: boolean;
  favoriteLinkId?: string;
  searchedAt?: string; // Timestamp when the search was performed

  // For new vertical layout - which category is expanded (null = show all categories)
  expandedCategory?: SearchEntityType | null;
}

export type UsersSearches = {
  recentSearches: Search[];
  favoriteSearches: Search[];
};

// Tab enum for global search
export enum GlobalSearchTab {
  All = "all",
  Legislation = "legislation",
  Workspace = "workspace",
  WorkspaceDocuments = "workspaceDocuments",
  Chat = "chat",
  FavoriteSearches = "favoriteSearches",
  /**
   * A search made on the Kilder page rather than in the search modal. Stored
   * alongside the other searches so it shows up in recent searches and can be
   * favorited from there, and reopened on the Kilder page (LAR-422).
   */
  Sources = "sources",
}

// View mode for the new global search modal
export type GlobalSearchViewMode = "initial" | "results" | "expanded";
